import styled from "styled-components";
import { grid, colorFullSroll } from "@mixins";
export var GridHolder = styled.div.withConfig({
  displayName: "styles__GridHolder",
  componentId: "sc-f4ev20-0"
})(["", " margin-bottom:10px;overflow-y:auto;", ""], grid(3, "10px 5px", null, true), function (_ref) {
  var theme = _ref.theme;
  return colorFullSroll(theme, "10px");
});